export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      noticeDeliveryInfo: {
        noticeDeliveryAt: 1234567890123,
        serviceName: "アイラ地域サポート",
        deliveryToKbn: 2,
        deliveryToDeviceSerial: 'DeviceSerial',
        deliveryStatus: 8,
        deliveryLocationCount: 141,
        openedLocationCount: 41,
        thumbupLocationCount: 39,
        deliverySpCount: 1200,
        openedSpCount: 722,
        thumbupSpCount: 697
      },
      deliveryContents: {
        title: '地元の名産品について',
        body: 'xxxxx',
        attachments: [],
        soundFile: [],
        linkUrl: 'http://www.google.co.jp',
        question: 'xxxxx',
        answerOptions: [],
        keikaiLevel: 0
      },
      deliveryTypeMstUuid: 'deliverytypemst001',
      noticeTypeMstUuid: 'noticeType001',
    }
  }
}